export default {
  "___activate-hsa_title_confirm-close": "",
  "___activate-hsa_text_confirm-close": "",
  "___activate-hsa_action_confirm-close_cancel": "",
  "___activate-hsa_action_confirm-close_confirm": "",
  "activate-hsa_step_welcome": "Welcome",
  "activate-hsa_step_account": "Account",
  "activate-hsa_step_agreement": "Agreement",
  "activate-hsa_title_enter-banking-information": "Enter Banking Information",
  "activate-hsa_title_final-review": "Final Review",
  "activate-hsa_title_terms-and-conditions": "Terms & Conditions",
  "activate-hsa_terms-and-conditions-action-statement": "Please review and agree to the terms and conditions linked below for activating your Health Savings Account.",
  "___activate-hsa_text_loading-message_loading-account": "",
  "activate-hsa_text_success-message_closed-account": "We're sorry to see you go. If you change your mind, give us a call at 1-800-859-2144.",
  "activate-hsa_action_open-account": "Yes, I'd like to open my account",
  "activate-hsa_action_close-account": "Decline",
  "___activate-hsa_action_continue": "",
  "___activate-hsa_action_done": "",
  "___activate-hsa_action_log-out": "",
  "___activate-hsa_action_refresh": "",
  "activate-hsa_option_1st-of-month": "1st of Each Month",
  "activate-hsa_option_5th-of-month": "5th of Each Month",
  "activate-hsa_option_10th-of-month": "10th of Each Month",
  "activate-hsa_option_15th-of-month": "15th of Each Month",
  "activate-hsa_option_25th-of-month": "25th of Each Month",
  "___activate-hsa_option_checking": "",
  "___activate-hsa_option_savings": "",
  "activate-hsa_text_over-hard-limit": "This contribution will put you over the maximum allowed by the IRS for the tax year.",
  "activate-hsa_action_over-hard-limit_confirm": "Ok",
  "activate-hsa_action_submit": "Submit & Enroll",
  "___activate-hsa_action_print": "",
  "activate-hsa_text_add-bank-account-error": "Your bank account cannot be added at this time. Please contact Customer Service for more information at 1-800-859-2144.",
  "activate-hsa_text_schedule-deposit-error": "Your deposit cannot added at this time. Please contact Customer Service for more information at 1-800-859-2144.",
  "activate-hsa_text_refresh-data-error-message_closed-account": "Your account has been closed but we were unable to refresh the data on the screen. Please refresh the page.",
  "activate-hsa_text_refresh-data-error-message_complete": "The activation process is complete but we were unable to refresh the data on the screen. Please refresh the page to view the portal.",
  "activate-hsa_text_refresh-data-error-message_navigate-to-accounts": "We are unable to navigate to the portal. Please refresh the page to view the portal.",
  "activate-hsa_action_go-to-portal": "Proceed to portal",

  // Form labels
  "___activate-hsa_form-label_token": "",
  "___activate-hsa_form-label_routing-number": "",
  "___activate-hsa_form-label_account-number": "",
  "___activate-hsa_form-label_confirm-account-number": "",
  "___activate-hsa_form-label_bank-name": "",
  "___activate-hsa_form-label_account-type": "",
  "activate-hsa_form-label_one-time-deposit": "Make a one-time deposit",
  "activate-hsa_form-label_one-time-amount": "One-time Amount",
  "activate-hsa_form-label_expected-post-date": "Expected Post Date",
  "activate-hsa_form-label_tax-year": "Tax Year",
  "activate-hsa_form-label_recurring-deposit": "Make a recurring deposit",
  "activate-hsa_form-label_recurring-amount": "Monthly Deposit Amount",
  "activate-hsa_form-label_monthly-deposit-day": "Monthly Deposit Day",
  "activate-hsa_form-label_terms-and-conditions": "I have read and agree to the terms and conditions linked above.",

  // Form errors
  "activate-hsa_form-error_account-type_required": "Select the account type",
  "activate-hsa_form-error_routing-number_required": "Enter the routing number",
  "activate-hsa_form-error_routing-number_invalid-format": "Invalid Routing Number",
  "activate-hsa_form-error_routing-number_invalid": "The Routing number entered is invalid",
  "activate-hsa_form-error_routing-number_length": "Invalid Routing Number",
  "activate-hsa_form-error_account-number_required": "Enter the account number",
  "activate-hsa_form-error_account-number_invalid-format": "Invalid Account Number",
  "activate-hsa_form-error_account-number_maxlength": "Account number cannot be longer than %maxLength% characters",
  "activate-hsa_form-error_confirm-account-number_required": "Re-enter the account number",
  "activate-hsa_form-error_confirm-account-number_same-as": "The Account Numbers entered do not match",
  "activate-hsa_form-error_bank-name_required": "Please enter a valid routing number",
  "activate-hsa_form-error_one-time-amount_required": "",
  "activate-hsa_form-error_one-time-amount_min-value": "A minimum deposit amount of $5 is required to establish your HSA.",
  "activate-hsa_form-error_one-time-amount_negative": "The deposit amount must be a positive number",
  "___activate-hsa_form-error_expected-post-date_date": "",
  "activate-hsa_form-error_expected-post-date_required": "Select a deposit date",
  "activate-hsa_form-error_expected-post-date_after-default-date": "Deposit date cannot be prior to %compareDate%",
  "activate-hsa_form-error_expected-post-date_before-end-date": "Deposit date must be prior to %compareDate%",
  "activate-hsa_form-error_tax-year_required": "Select a tax year",
  "activate-hsa_form-error_recurring-amount_required": "",
  "activate-hsa_form-error_recurring-amount_negative": "The deposit amount must be a positive number",
  "activate-hsa_form-error_recurring-amount_min-value": "Deposit amount must be greater than $0.00.",
  "activate-hsa_form-error_monthly-deposit-day_required": "Select a monthly deposit day",
  "___activate-hsa_form-error_terms-and-conditions_required": ""
};